import { MdContentPaste, MdFolder, MdSchedule, MdSend, MdSettings } from 'react-icons/md';
import type { IconType } from 'react-icons';

export const candidateMailFolders = [
  'sent',
  'scheduled',
  'archive',
  'templates',
  'settings',
] as const;

export type CandidateMailFolder = (typeof candidateMailFolders)[number];

export type CandidateMailNavItem = {
  folder: CandidateMailFolder;
  label: string;
  icon: IconType;
};

export const candidateMailBoxNavItems: readonly CandidateMailNavItem[] = [
  { folder: 'sent', label: '送信済み', icon: MdSend },
  { folder: 'scheduled', label: '送信予定', icon: MdSchedule },
  { folder: 'archive', label: 'アーカイブ', icon: MdFolder },
];

export const candidateMailManageNavItems: readonly CandidateMailNavItem[] = [
  { folder: 'templates', label: 'テンプレート', icon: MdContentPaste },
  { folder: 'settings', label: '設定', icon: MdSettings },
];

export const CANDIDATE_MAIL_PAGE_SIZE = 50;

export interface CandidateMailReplaceToken {
  key: string;
  label: string;
  token: string;
}

export const candidateMailReplaceTokens: CandidateMailReplaceToken[] = [
  { key: 'name', label: '求職者氏名', token: '#[候補者名]' },
  { key: 'company', label: '会社名', token: '#[会社名]' },
  { key: 'staff', label: '担当者氏名', token: '#[担当者氏名]' },
];

// #[NAME] は改名前、#[求職者氏名] は表示名で手入力された本文の互換用（サーバー側 CandidateMailer と揃える）
export const legacyCandidateMailReplaceTokens: CandidateMailReplaceToken[] = [
  { key: 'name', label: '求職者氏名', token: '#[NAME]' },
  { key: 'name', label: '求職者氏名', token: '#[求職者氏名]' },
];

// サーバー側 CandidateMailer#send_mail の From と揃える（設定のメールアドレスは Reply-To になる）
export const CANDIDATE_MAIL_FROM_ADDRESS = 'no-reply@agenthub.jp';

// サーバー側 CandidateMail::SEND_UNDO_WINDOW と揃える
export const SEND_UNDO_WINDOW_MS = 60_000;

// サーバー側 CandidateMail::SCHEDULE_* と揃える
export const SCHEDULE_MIN_LEAD_MINUTES = 5;
export const SCHEDULE_MAX_DAYS = 30;
export const SCHEDULE_STEP_MINUTES = 15;
